import { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { domainConfigs } from './config/domains'
import { AuthProvider } from './context/AuthContext'
import { CartProvider } from './context/CartContext'
import { SearchProvider } from './context/SearchContext'
import Routes from './routes'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ReactTooltip from 'react-tooltip'
import { ThemeContextProvider } from './context/ThemeContext'

const App = () => {
  useEffect(() => {
    const currentConfig = domainConfigs.find(config => window.location.hostname.includes(config.domain))

    if (currentConfig) {
      document.title = currentConfig.title

      if (currentConfig.favicon) {
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        link.href = currentConfig.favicon
        document.getElementsByTagName('head')[0].appendChild(link)
      }
    }
  }, [])

  return (
    <ThemeContextProvider>
      <AuthProvider>
        <CartProvider>
          <Router>
            <SearchProvider>
              <Routes />
            </SearchProvider>
          </Router>
          <ReactTooltip className='default-tooltip' />
          <ToastContainer
            autoClose={3000}
            position='bottom-right'
            theme='colored'
            pauseOnHover={false}
            draggable={false}
            pauseOnFocusLoss={false}
          />
        </CartProvider>
      </AuthProvider>
    </ThemeContextProvider>
  )
}

export default App
